import React from 'react';

export default function Paginator({ page, totalPages, totalItems, pageSize, onChange }) {
  if (totalPages <= 1) return null;

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  const getPageNumbers = () => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);
    const pages = [1];
    if (page > 3) pages.push('...');
    for (let i = Math.max(2, page - 1); i <= Math.min(totalPages - 1, page + 1); i++) {
      pages.push(i);
    }
    if (page < totalPages - 2) pages.push('...');
    pages.push(totalPages);
    return pages;
  };

  const btnStyle = (active, disabled) => ({
    minWidth: 34, height: 34, borderRadius: 7,
    border: `1px solid ${active ? '#F97316' : 'var(--border)'}`,
    background: active ? '#F97316' : 'var(--surface)',
    color: active ? '#fff' : disabled ? 'var(--text-muted)' : 'var(--text-secondary)',
    fontSize: 13, fontWeight: active ? 700 : 400,
    cursor: disabled ? 'default' : 'pointer',
    padding: '0 8px', transition: 'all 0.15s',
  });

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 20, flexWrap: 'wrap', gap: 12 }}>
      <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>
        Showing {start}–{end} of {totalItems}
      </div>
      <div style={{ display: 'flex', gap: 5, alignItems: 'center' }}>
        <button onClick={() => onChange(page - 1)} disabled={page === 1} style={btnStyle(false, page === 1)}>←</button>
        {getPageNumbers().map((p, i) =>
          p === '...' ? (
            <span key={`ellipsis-${i}`} style={{ color: 'var(--text-muted)', fontSize: 13, padding: '0 2px' }}>…</span>
          ) : (
            <button key={p} onClick={() => onChange(p)} style={btnStyle(p === page, false)}>{p}</button>
          )
        )}
        <button onClick={() => onChange(page + 1)} disabled={page === totalPages} style={btnStyle(false, page === totalPages)}>→</button>
      </div>
    </div>
  );
}
